module.exports = {
  camera: {
    position: {
      x: 0,
      y: 70,
      z: 420,
    }
  },
  block: {
    position: {
      x:0,y:5,z:10,
    }
  },
  ball: {
    position: {
      x: 0, y: 6, z: 130
    },
    positionOriginal: {
      x: 0, y: 6, z: 130
    }
  },
  lights: {
    position: {
      x: 0, y: 350, z: 500
    }
  },
  blocks: {
    rotation: {
      x: 0, y: 0, z: 0,
    }
  },
  sphere: {
    rotation: {
      x: 0, y: 0, z: 0,
    }
  },
  innerSphere: {
    rotation: {
      x: 0, y: 0, z: 0,
    }
  },
};



/** WEBPACK FOOTER **
 ** ./src/data.js
 **/